import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { GlobalVariable } from "app/global/global";
import { Orden, CrearOrdenRequest } from "app/models/orden.interface";

@Injectable({
  providedIn: "root",
})
export class OrdenService {
  private readonly url = `${GlobalVariable.BASE_API_URL}api/ordenes/`;

  constructor(private http: HttpClient) {}

  crear(data: CrearOrdenRequest): Observable<Orden> {
    return this.http.post<Orden>(`${this.url}crear`, data);
  }

  listar(
    filtros?: Record<string, string | number>,
    page?: number,
    perPage?: number,
  ): Observable<any> {
    let params = new HttpParams();
    if (page != null) {
      params = params.set("page", page.toString());
    }
    if (perPage != null) {
      params = params.set("per_page", perPage.toString());
    }
    if (filtros) {
      for (const [key, value] of Object.entries(filtros)) {
        if (value != null) {
          params = params.set(key, value.toString());
        }
      }
    }
    return this.http.get<any>(`${this.url}listar`, { params });
  }

  mostrar(id: number): Observable<Orden> {
    return this.http.get<Orden>(`${this.url}mostrar/${id}`);
  }

  porPaciente(pacienteId: number): Observable<Orden[]> {
    return this.http.get<Orden[]>(`${this.url}paciente/${pacienteId}`);
  }

  porMedico(medicoId: number): Observable<Orden[]> {
    return this.http.get<Orden[]>(`${this.url}medico/${medicoId}`);
  }
}
